import { PayloadAction, createSlice } from '@reduxjs/toolkit';


export interface MeetingDetailItemObject {
  id: number;
  name: string;
  organizer: string;
  reportType: number;
  country: string;
  date: string;
  link: string;
  type: number;
  hasInstantMeetings: boolean;
  reportId: string;
}

type InstantMeetingState = {
  item: MeetingDetailItemObject,
  loading: boolean,
  error: boolean,
  isMeetingSent: boolean,
};
const initialState: InstantMeetingState = {
  item: {
    id: -1,
    name: '',
    organizer: '',
    reportType: -1,
    country: '',
    date: '',
    link: '',
    type: -1,
    hasInstantMeetings: false,
    reportId: '',
  },
  loading: false,
  error: false,
  isMeetingSent: false,

};

export const instantMetting = createSlice({
  name: 'instantMeeting',
  initialState,
  reducers: {
    setItem: (state, action: PayloadAction<MeetingDetailItemObject>) => {
      state.item = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
    setIsMeetingSent: (state, action: PayloadAction<boolean>) => {
      state.isMeetingSent = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setItem,
  setLoading,
  setError,
  setIsMeetingSent,
} = instantMetting.actions;

export default instantMetting.reducer;